export * from './types.js';
export * from './build-in-string.js';
export * from './build-in-intl-segmenter.js';

/**
 * grapheme-splitter 作为外部模块, 按需引入
 */
// export * from "./grapheme-splitter.js";
